/* Load Modules */
import {memoize} from "lodash";
/* Load Utils */
import buildFormGridFields from "../../../../../../../utils/forms/builders/build-form-grid-fields";
import buildSchemaCompliantDefinition
    from "../../../../../../../utils/forms/builders/build-schema-compliant-definition";
/* Load Components */
import {SubFormDefinition} from "../../../../../../../utils/forms/components/FormSet";

import {GROUP_TYPE} from "../../../../../reducers/editingConfiguration.reducer";
import groupListOfType from "../../../../Utils/full-group-list";
import {parseAvailableGroups} from "../../../../Utils/parse-available-groups";
import {
    mrChampionFormDefinition,
    pigBoomFormDefinition,
    SCHEMA_NAMES
} from "./SpecialPrizesConfigurationSection.constants";
/* Load Defaults */
import {defaultMrChampion, defaultPigBoom} from "./SpecialPrizesConfigurationSection.defaults";

export const mrChampionSubForms = props =>
    memoize(
        ({
            terminalGroups,
            gameGroups,
            selectedTerminalGroups,
            selectedGameGroups,
            schema,
            selectedGroupType,
            mrChampionConfig,
            rules
        }): SubFormDefinition[] => {
            const fullGroupList = groupListOfType(
                selectedGroupType,
                terminalGroups,
                gameGroups
            );

            const selectedGroupList = parseAvailableGroups(
                terminalGroups,
                selectedTerminalGroups,
                gameGroups,
                selectedGameGroups,
                "mr_champion",
                selectedGroupType
            );

            const mrChampionSchema = schema.definitions.$mr_champion;

            const requiredGroupFields =
                selectedGroupType == null
                    ? "groups_placeholder"
                    : selectedGroupType == GROUP_TYPE.GAME
                    ? "game_groups"
                    : "terminal_groups";

            mrChampionSchema["required"] = [requiredGroupFields, "contribution"];

            const formDefinition = buildSchemaCompliantDefinition(
                mrChampionSchema,
                mrChampionFormDefinition(
                    selectedGroupType,
                    fullGroupList,
                    selectedGroupList,
                    rules.presets.map(preset => {
                        return {
                            value: preset.id,
                            label: preset.name,
                            individual_pot: null,
                            certified: preset.certified
                        };
                    }),
                ),
                [
                    SCHEMA_NAMES.ID,
                    SCHEMA_NAMES.GROUPS,
                    SCHEMA_NAMES.PRIZE_PARAMETERS_GROUP,
                    SCHEMA_NAMES.TIME_PARAMETERS_GROUP,
                    SCHEMA_NAMES.SECURITY_PARAMETERS_GROUP,
                    SCHEMA_NAMES.CONTRIBUTION
                ]
            );

            const formGridFields = buildFormGridFields(
                mrChampionSchema,
                formDefinition,
                schema
            )

            formGridFields.map(field =>{
                if(field.name === "id"){
                    field.validationSchema["unique"] = mrChampionConfig.map(mrChampion => mrChampion.id);

                }
            })

            return [
                {
                    formType: "mrChampion",
                    fields: formGridFields,
                    addLabel: "Add",
                    emptyValue: defaultMrChampion({
                        schema: mrChampionSchema,
                        mrChampionConfig: mrChampionConfig
                    })
                }
            ];
        }
    );

export const pigBoomSubForms = props =>
    memoize(
        ({
            terminalGroups,
            gameGroups,
            selectedTerminalGroups,
            selectedGameGroups,
            schema,
            selectedGroupType,
            pigBoomConfig,
            rules
        }): SubFormDefinition[] => {
            const fullGroupList = groupListOfType(
                selectedGroupType,
                terminalGroups,
                gameGroups
            );

            const selectedGroupList = parseAvailableGroups(
                terminalGroups,
                selectedTerminalGroups,
                gameGroups,
                selectedGameGroups,
                "pig_boom",
                selectedGroupType
            );

            const pigBoomSchema = schema.definitions.$pig_boom;

            const requiredGroupFields =
                selectedGroupType == null
                    ? "groups_placeholder"
                    : selectedGroupType == GROUP_TYPE.GAME
                    ? "game_groups"
                    : "terminal_groups";

            pigBoomSchema["required"] = [requiredGroupFields, "contribution"];

            const formDefinition = buildSchemaCompliantDefinition(
                pigBoomSchema,
                pigBoomFormDefinition(
                    selectedGroupType,
                    fullGroupList,
                    selectedGroupList,
                    rules.presets.map(preset => {
                        return {
                            value: preset.id,
                            label: preset.name,
                            individual_pot: null,
                            certified: preset.certified
                        };
                    }),
                ),
                [
                    SCHEMA_NAMES.ID,
                    SCHEMA_NAMES.GROUPS,
                    SCHEMA_NAMES.PRIZE_PARAMETERS_GROUP,
                    SCHEMA_NAMES.TIME_PARAMETERS_GROUP,
                    SCHEMA_NAMES.SECURITY_PARAMETERS_GROUP,
                    SCHEMA_NAMES.CONTRIBUTION
                ]
            );


            const formGridFields = buildFormGridFields(
                pigBoomSchema,
                formDefinition,
                schema
            )

            formGridFields.map(field =>{
                if(field.name === "id"){
                    field.validationSchema["unique"] = pigBoomConfig.map(mrChampion => mrChampion.id);

                }
            })

            return [
                {
                    formType: "pigBoom",
                    fields: formGridFields,
                    addLabel: "Add",
                    emptyValue: defaultPigBoom({
                        schema: pigBoomSchema,
                        pigBoomConfig: pigBoomConfig
                    })
                }
            ];
        }
    );
